<template>
  <base-page-layout title="Gestão de ofertas" :filters="['lojas', 'produtos']" :check-all-units-on-init="false" hide-ecommerce-configuration>
    <div class="tabs-button-header">
      <mf-tabs-menu v-model="tab" :tabs="tabs" />
      <div class="tab-buttons">
        <export-all-sales-modal />
        <mf-button v-if="tab !== 2" icon="add" data-cy="newOffer" label="Nova campanha" @click="$router.push('/campanhas/gestao-ofertas/nova')" />
      </div>
    </div>

    <div v-if="tab === 0" :key="tab">
      <campaigns-table
        v-if="isFranchisee"
        class="mb-3"
        :franchisee="true"
        :units="units"
        :units-configuration="unitsConfiguration"
        :products="products"
        :itemsFilter="filterListFranchisee[tab]"
        :default-table-sort-by="['updated_at']"
        :default-table-sort-desc="true"
      >
        <template v-slot:title> Ofertas da rede </template>
      </campaigns-table>
      <campaigns-table
        class="mb-3"
        :units="units"
        :units-configuration="unitsConfiguration"
        :products="products"
        :itemsFilter="filterList[tab]"
        :default-table-sort-by="['updated_at']"
        :default-table-sort-desc="true"
      >
        <template v-slot:title> Minhas ofertas</template>
      </campaigns-table>
    </div>

    <div v-if="tab === 1" :key="tab">
      <campaigns-table
        v-if="isFranchisee"
        class="mb-3"
        :franchisee="true"
        :units="units"
        :units-configuration="unitsConfiguration"
        :products="products"
        :itemsFilter="filterListFranchisee[tab]"
        :default-table-sort-by="['updated_at']"
        :default-table-sort-desc="true"
      >
        <template v-slot:title> Ofertas da rede </template>
      </campaigns-table>

      <campaigns-table
        class="mb-3"
        :units="units"
        :units-configuration="unitsConfiguration"
        :products="products"
        :itemsFilter="filterList[tab]"
        :default-table-sort-by="['updated_at']"
        :default-table-sort-desc="true"
      >
        <template v-slot:title> Minhas ofertas </template>
      </campaigns-table>
    </div>
  </base-page-layout>
</template>

<script>
import BasePageLayout from '@/components/BasePageLayout.vue'
import CampaignsTable from '@/modules/campanhas/gestao-ofertas-v2/views/components/CampaignsTable.vue'
import { getStatusLabel } from '@/config/helpers.js'
import { mapState } from 'vuex'

export default {
  name: 'OfferSales',
  components: {
    BasePageLayout,
    CampaignsTable,
    ExportAllSalesModal: () => import('@/modules/campanhas/gestao-ofertas-v2/views/components/ExportAllSalesModal.vue'),
  },
  data() {
    return {
      tab: 0,
      filterListFranchisee: [
        [
          { label: getStatusLabel('ACTIVE').text, value: 'active', color: getStatusLabel('ACTIVE').color, active: true },
          { label: getStatusLabel('SCHEDULED').text, value: 'scheduled', color: getStatusLabel('SCHEDULED').color, active: true },
        ],
        [{ label: getStatusLabel('FINISHED').text, value: 'finished', color: getStatusLabel('FINISHED').color, active: true }],
      ],
      filterList: [
        [
          { label: getStatusLabel('DRAFT').text, value: 'draft', color: getStatusLabel('DRAFT').color, active: true },
          { label: getStatusLabel('ACTIVE').text, value: 'active', color: getStatusLabel('ACTIVE').color, active: true },
          { label: getStatusLabel('SCHEDULED').text, value: 'scheduled', color: getStatusLabel('SCHEDULED').color, active: true },
        ],
        [{ label: getStatusLabel('FINISHED').text, value: 'finished', color: getStatusLabel('FINISHED').color, active: true }],
      ],
    }
  },
  computed: {
    ...mapState({
      units: (state) => state.filters.units || [],
      unitsConfiguration: (state) => state.filters.unitsConfiguration,
      products: (state) => state.filters.products,
    }),
    isFranchise() {
      // rede
      if (!this.$getLoggedUser().is_franchise) return false
      return this.$getLoggedUser().is_franchise
    },
    isFranchisee() {
      // franquia
      if (!this.$getLoggedUser().is_franchisee) return false
      return this.$getLoggedUser().is_franchisee
    },

    tabs() {
      return [
        {
          name: 'Ofertas ativas',
          itemsLength: 0,
          haveLength: false,
        },
        {
          name: 'Histórico',
          itemsLength: 0,
          haveLength: false,
        },
      ]
    },
  },
}
</script>

<style lang="scss" scoped>
.tabs-button-header {
  position: relative;
  margin-bottom: 20px;
  .tab-buttons {
    position: absolute;
    top: 5px;
    right: 0;
  }
}
</style>
